const TYPE = {
    APPOINTMENT_CONFIRMATION: 1,
    APPOINTMENT_REMINDER: 2,
    BIRTHDAY: 3,
    BOARDING_CONFIRMATION: 4,
    BOARDING_REMINDER: 5,
    CERTIFICATE: 6,
    CHECKOUT_DOCUMENT: 7,
    DEPOSIT: 8,
    ESTIMATE: 9,
    INVOICE: 10,
    LETTER: 11,
    MEDICAL_NOTE: 12,
    MEDICAL_REMINDER: 13,
    PATIENT_HISTORY: 14,
    RETURN: 15,
    STATEMENT: 16,
    APPOINTMENT_ACCEPT: 17,
    APPOINTMENT_RESCHEDULE: 18,
    APPOINTMENT_DECLINE: 19,
    LAB: 20,
    RECEIPT: 21
};

export default {
    TYPE
};
